import React from 'react'
import { Box } from '@mui/material'
import { Embroidery } from 'src/types'
import { useLocale } from 'src/locales/useLocale'
import { NoEmbroidery } from 'src/features/simulationConfirm/Components/NoEmbroidery'
import { ItemCell } from 'src/Components/Domain/ItemCell'
import { muiGrey } from 'src/style/muiTheme'
import { cellColor } from './SimulationContents'
import { genShoesEmbroideryCells } from 'src/logic/simulationSpecification/shoes'

type Props = {
  embroideries: Embroidery[]
  previousIndex: number
}

export const ShoesEmbroideries: React.FC<Props> = ({ embroideries, previousIndex }) => {
  const { t } = useLocale()
  if (embroideries.filter((e) => e.content.trim().length > 0).length === 0) {
    return <NoEmbroidery />
  }
  return (
    <>
      {embroideries
        .filter((e) => e.content.trim().length > 0)
        .map((embroidery, index) => {
          const embroideryCells = genShoesEmbroideryCells(embroidery, t)
          return (
            <React.Fragment key={`${index}`}>
              {embroidery.content.trim().length > 0 && (
                <Box mb={2}>
                  <Box fontWeight="bold" fontSize="16px" color={muiGrey}>
                    {t.EMBROIDERY_ITEMS}
                    {index + 1}
                  </Box>
                  {embroideryCells.map((cell, i) => (
                    <ItemCell key={cell.head} itemIndex={i + previousIndex + index * 6} cell={cell} color={cellColor(cell?.value)} />
                  ))}
                </Box>
              )}
            </React.Fragment>
          )
        })}
    </>
  )
}
